import { ReactNode } from "react";
import { Icon } from "react-bootstrap-icons";
import {
  MetadataBody,
  MetadataItem,
  MetadataLabel,
  MetadataValue,
} from "../styled";

interface ShowItemProps {
  icon: Icon;
  label: string;
  children: ReactNode;
}

const ShowItem = ({ icon: IconComp, label, children }: ShowItemProps) => {
  return (
    <MetadataItem>
      <IconComp size={16} />
      <MetadataBody>
        <MetadataLabel>{label}</MetadataLabel>
        <MetadataValue>{children}</MetadataValue>
      </MetadataBody>
    </MetadataItem>
  );
};

export default ShowItem;
